import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Audit } from '@models/audit.model';
import { PagedResponse } from '@models/response.model';

import { TableConfig } from '@app/shared/util/table-config.utils';
import { AppUtils } from '@app/shared/util/app.utils';

import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";

@Injectable()
export class AuditsService {

    static readonly AUDITS_API_GET_PATH = `${environment.baseURL}/api/audit`;
    static readonly AUDITS_API_DOWNLOAD_PATH = `${environment.baseURL}/api/audit/download`;

    constructor(private http: HttpClient) {
    }

    requestAudits(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<Audit>>(AuditsService.AUDITS_API_GET_PATH, {params: params})
            .pipe(map(this.mapAudits));
    }

    mapAudits = res => {
        return {
            audits: res.items.map(audit => new Audit(audit)),
            count: res.total
        };
    };

    downloadAudits(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(AuditsService.AUDITS_API_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }
}
